import { Card, CardBody, Col, Row } from "reactstrap"
import CommonCardHeader from "../../../../Common/CommonCardHeader"
import { CustomRadios } from "../../../../Constant"
import { CUSTOM_RADIO } from "../../../../Data/FormControl/CheckboxAndRadio"
import { BorderedRadio } from "./BorderedRadio"
import { IconsRadio } from "./IconsRadio"
import { FilledRadio } from "./FilledRadio"

const CustomRadio = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CustomRadios} span={CUSTOM_RADIO} />
        <CardBody>
          <Row className="g-3">
            <BorderedRadio />
            <IconsRadio />
            <FilledRadio />
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default CustomRadio